PJQ.collections.dailyReports = {};

PJQ.models.dailyReports = {};

PJQ.views.dailyReports = {};

//Routes
PJQ.modules.dailyReports = {
	routes: [
		{
			route: 'projects/:projectId/dailyreports',
			name: 'dailyReports',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "dailyreports");
			}
		},
		{
			route: 'projects/:projectId/dailyreports/:date',
			name: 'dailyReportDate',
			callback: function (projectId, date) {
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "dailyreports", {
						date: PJQ.helpers.dateHelpers.tryParseDateString(date)
					});
				}
				else{
					window.dailyReportDate = date;
					PJQ.modules.pjqProjectWall.initProjectWallAdmin(projectId);
				}
			}
		},
		{
			route: 'projects/:projectId/dailyreports/:date/:tab',
			name: 'dailyReportDateTab',
			callback: function (projectId, date, tab) {
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "dailyreports", {
						date: PJQ.helpers.dateHelpers.tryParseDateString(date),
						tab: tab
					});
				}
				else{
					window.dailyReportDate = date;
					window.dailyReportTab = tab;
					PJQ.modules.pjqProjectWall.initProjectWallAdmin(projectId);
				}
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.dailyReports.routes);